<!-- SarhSoft Cross-PlatForm Engine Project-->
<!-- Languages: PHP, JavaScript, Node, Java.
  BackEnd: Laravel.
  FrontEnd: Vue2.
  Project Type: (Laravel,Vue Mixin) Java Cross Frame.
  Written By: M.Farhat,
  Email: m.farhat@sarhsoft.com.
  Copyright © 2022 SarhSoft All rights reserved.
-->
<template>
  <app-card :title="getPageTitle()" class="px-1" icon="mdi-clipboard-text">
    <app-datatable ref="datatable" :formDialog.sync="dialog" :formDialogLoading.sync="formDialogLoading" :headers="headers" :modalTitle="datatableDialogTitle" :url="tableUrl" center excel pdf search fullscreen>
      <template #formDialog="props">
        <div class="pt-2">
          <app-form ref="form" v-slot="v" :errors="formErrors" :submit="submitForm">
            <app-row class="pa-0 ma-0">
              <app-text-input v-model="selectedItem.product_sku" name="product_sku" sm="12" md="4" rules="required"/>
              <app-auto-select v-model="selectedItem.product_type" :items="product_types" rules="required" name="product_type" sm="12" md="4"/>
              <app-text-input v-if="selectedItem.product_type===2" v-model="selectedItem.name_ar" name="name_ar" sm="12" md="4"/>
              <app-text-input v-if="selectedItem.product_type===2" v-model="selectedItem.name_en" name="name_en" sm="12" md="4"/>
              <app-manufacturers @change="UpdateModels" v-if="selectedItem.product_type===1" v-model="selectedItem.manufacturer_id"  name="manufacturer_id" sm="12" md="4"/>
              <app-auto-select v-if="selectedItem.product_type===1" v-model="selectedItem.product_model_id" :items="product_models" name="product_model_id" sm="12" md="4"/>
              <app-product-years v-if="selectedItem.product_type===1" v-model="selectedItem.product_year_id"  name="product_year_id" sm="12" md="4"/>
              <app-number-input v-if="selectedItem.product_type===1" v-model="selectedItem.km" name="car_km" :format="true" sm="12" md="4"/>
              <app-text-input v-if="selectedItem.product_type===1" v-model="selectedItem.chassie" name="chassie" sm="12" md="4"/>
              <app-product-colors v-if="selectedItem.product_type===1" v-model="selectedItem.product_out_color_id"  name="product_out_color_id" sm="12" md="4"/>
              <app-product-colors v-if="selectedItem.product_type===1" v-model="selectedItem.product_in_color_id"  name="product_in_color_id" sm="12" md="4"/>
              <app-import-types v-if="selectedItem.product_type===1" v-model="selectedItem.import_type_id"  name="import_type_id" sm="12" md="4"/>
              <app-fuel-types v-if="selectedItem.product_type===1" v-model="selectedItem.fuel_type_id"  name="fuel_type_id" sm="12" md="4"/>
              <app-number-input v-model="selectedItem.price" name="price" :format="true" sm="12" md="4"/>
              <app-number-input v-if="selectedItem.product_type===1" v-model="selectedItem.down_payment" name="down_payment" :format="true" sm="12" md="4"/>
              <app-textarea-input v-model="selectedItem.notes" name="product_notes" sm="12" md="12"/>
            </app-row>
            <app-row>
              <v-col>
                <app-submit :loading="formDialogLoading">{{ $t('save') }}</app-submit>
              </v-col>
            </app-row>
          </app-form>
        </div>
      </template>
      <template #item.control="{item}">
        <app-btn-med md="6" sm="12"v-if="HasEditPermission()" update @click="FetshafterEdit(item)"/>
        <app-btn-med md="6" sm="12"v-if="HasDeletePermission()" destroy @click="deleteItem(item)" />
      </template>
    </app-datatable>
  </app-card>
</template>
<script>
import DatatableMixin from '@mixins/DatatableMixin'
import MetaInfoMixin from '@mixins/MetaInfoMixin'
export default {
  name: 'Index',
  helperApiName: 'product',
  mixins: [MetaInfoMixin, DatatableMixin],
  data() {
    return {
      headers: [
        'id',
        'product_sku',
        {text: this.parseAttribute("name"), value: 'name_to_string'},
        {text: this.parseAttribute("product_type"), value: 'product_type_to_string'},
        'price',
        'down_payment',
        'control',
        ],
      product_models:[],
    }
  },
  methods: {
    FetshafterEdit(item={}){
      this.showEditDialog(item);
      this.selectedItem.manufacturer_id = item.manufacturer_id;
      this.$nextTick(() => this.UpdateModels());
    },
    UpdateModels(){
      if(this.selectedItem.manufacturer_id&&this.selectedItem.manufacturer_id>0){
        this.$axios.get(`Panel/GetProductModelsByManufacturer`, {params: {
            manufacturer_id: this.selectedItem.manufacturer_id,
          }})
          .then(resdata => {
            this.product_models = resdata.data.data;
          }).catch(errordata => {
          console.log(errordata.response);
        });
      }
    },
  },
  mounted() {
    if(this.selectedItem.manufacturer_id&&
      this.selectedItem.manufacturer_id>0&&
      this.selectedItem.product_type===1){
      this.UpdateModels();
    }
  }
}
</script>
